module.exports = __webpack_public_path__ + "img/26.c0e6e1f4.jpg";